export const EXTERNAL_SSO_REDIRECT_URL_METADATA_KEY =
  'external_sso_redirect_url';
export const EXTERNAL_SSO_CODE_PARAM = 'external_sso_code';
export const EXTERNAL_SSO_CODE_MESSAGE_TYPE = 'EXTERNAL_SSO_CODE';

export function postExternalSsoCodeToOpener(code: string): boolean {
  if (!window.opener) {
    return false;
  }

  window.opener.postMessage(
    { type: EXTERNAL_SSO_CODE_MESSAGE_TYPE, code },
    window.location.origin
  );
  window.close();

  return true;
}
